import { getStyle } from './getStyle';
import * as React from 'react';
import { WpdfText } from '../../pdf/WpdfText.';
import { WpdfView } from '../../pdf/WpdfView';

export function getAnhang(
    isPdf: boolean, anhang: JSX.Element[], getPageNum?: (key: string, page: number, level: number) => void, heading?: string,
    noPageHeader?: boolean, level?: number
): JSX.Element[] {
    return (anhang || []).map((item: JSX.Element, index: number) => {
        heading = heading !== null ? (heading ? heading : `Anhang ${index + 1}`) : null;
        return (
            <WpdfView
                key={`anhang_${index}`}
                style={{ ...(item ? getStyle('div') : {}) }}
                pdf={isPdf}
            >
                {heading !== null &&
                    <WpdfText
                        pdf={isPdf}
                        style={{
                            ...getStyle('h1', isPdf), marginBottom: '12pt',
                            ...(!index && isPdf && { marginTop: 0 }),
                            ...(noPageHeader && { maxHeight: 0, margin: 0 })
                        }}
                        getPageNum={(pageNumber: number) => typeof getPageNum === 'function' && getPageNum(heading, pageNumber, level || 1)}
                    >
                        {!noPageHeader && heading}
                    </WpdfText>
                }
                {item}
            </WpdfView>
        );
    });
}

export function getAnhangExtraDokumente(isPdf: boolean, documents: any[], getPageNum?: (key: string, page: number, level: number) => void): JSX.Element {
    const heading = 'Anhang';
    return (
        <WpdfView
            style={getStyle('div')}
            pdf={isPdf}
        >
            <WpdfText
                pdf={isPdf}
                style={{
                    ...getStyle('h1', isPdf), marginBottom: '12pt',
                    ...(isPdf && { marginTop: 0 })
                }}
                getPageNum={(pageNumber: number) => typeof getPageNum === 'function' && getPageNum(heading, pageNumber, 1)}
            >
                {heading}
            </WpdfText>
            {(documents).map((doc: any, idx: number) =>
                <WpdfText
                    pdf={isPdf}
                    style={{}}
                >
                    {`${idx + 1}. ${doc.name}`}
                </WpdfText>
            )}
        </WpdfView>
    );
}
